import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { QRCodeSVG } from 'qrcode.react';


const QRAccessControl = () => {
  const [formData, setFormData] = useState({
    emails: '',
    unit_id: '',
    recipient_name: '',
    access_type: 'permanent'
  });

  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
        const response = await fetch('/api/create-access-card', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error('Server response:', errorText);
            throw new Error(`Server error: ${response.status}`);
        }

        const data = await response.json();
        if (data.error) {
            throw new Error(data.error);
        }

        setResponse(data);
        
    } catch (err) {
        setError(err.message);
        console.error('Error details:', err);
    } finally {
        setIsLoading(false);
    }
};

  return (
    <div className="max-w-2xl mx-auto">
      <Card>
        <CardHeader>
          <CardTitle>Generate QR Access Code</CardTitle>
          <CardDescription>
            Create a new access card with QR code
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label className="text-sm font-medium">Email</label>
              <Input
                type="email"
                required
                value={formData.emails}
                onChange={(e) => setFormData(prev => ({ ...prev, emails: e.target.value }))}
                placeholder="Enter email address"
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium">Unit ID</label>
              <Input
                type="text"
                required
                value={formData.unit_id}
                onChange={(e) => setFormData(prev => ({ ...prev, unit_id: e.target.value }))}
                placeholder="Enter unit ID"
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium">Recipient Name</label>
              <Input
                type="text"
                required
                value={formData.recipient_name}
                onChange={(e) => setFormData(prev => ({ ...prev, recipient_name: e.target.value }))}
                placeholder="Enter recipient name"
              />
            </div>

            <Button 
              type="submit" 
              className="w-full"
              disabled={isLoading}
            >
              {isLoading ? 'Generating...' : 'Generate QR Code'}
            </Button>
          </form>

          {error && (
            <div className="mt-4 p-4 bg-red-50 text-red-600 rounded-md">
              {error}
            </div>
          )}

        {response && response.created_codes && response.created_codes.length > 0 && (
            <div className="mt-4 space-y-4">
              {response.created_codes.map((code, index) => (
                <Card key={index} className="bg-green-50">
                  <CardHeader>
                    <CardTitle className="text-lg">Access Card Created</CardTitle>
                    <CardDescription>
                      {response.message}
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    {/* QR Code Display */}
                    <div className="flex justify-center bg-white p-4 rounded-lg">
                      <QRCodeSVG
                        value={code.qr_code}
                        size={200}
                        level="H"
                        includeMargin={true}
                        className="border-8 border-white"
                      />
                    </div>
                    
                    {/* Card Details */}
                    <div className="space-y-2 bg-white p-4 rounded-lg">
                      <div className="flex justify-between">
                        <span className="font-medium">QR Code:</span>
                        <span className="font-mono">{code.qr_code}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="font-medium">Email:</span>
                        <span>{code.email}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="font-medium">Recipient:</span>
                        <span>{code.recipient_name}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="font-medium">Unit:</span>
                        <span>{code.unit_id} ({code.description})</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="font-medium">Floor:</span>
                        <span>{code.floor}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="font-medium">Type:</span>
                        <span className="capitalize">{code.type}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="font-medium">Status:</span>
                        <span className="capitalize text-green-600">
                          {code.status}
                        </span>
                      </div>
                    </div>

                    {/* Download/Print Options */}
                    <div className="flex gap-2">
                      <Button
                        onClick={() => window.print()}
                        className="flex-1"
                        variant="outline"
                      >
                        Print QR Code
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default QRAccessControl;